import { render, staticRenderFns } from "./DangKyDDATList.vue?vue&type=template&id=0ea490a5&"
import script from "./DangKyDDATList.vue?vue&type=script&lang=js&"
export * from "./DangKyDDATList.vue?vue&type=script&lang=js&"
import style0 from "./DangKyDDATList.vue?vue&type=style&index=0&id=0ea490a5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports